import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import { useSelector } from "react-redux";
import TablePaginationActions from "../../../shared/components/Table/Actions";
import { dateTimeFormat } from "../../../util/DateUtil";
import Loading from "../../UI/Loading";
import ComunicadoStatusChip from "./ComunicadoStatusChip";

export default function ComunicadoTable({
  comunicados,
  isLoading = false,
  handleChangePage,
  setComunicado,
}) {
  const usuario = useSelector((state) => state.usuario);
  const comunicadoAprovacao = usuario.instituicao.comunicadoAprovacao;

  if (isLoading) {
    return (
      <Box py={6}>
        <Loading description="Carregando Comunicados..." />
      </Box>
    );
  }

  if (comunicados.content.length === 0) {
    return (
      <Box
        sx={{
          py: 6,
          textAlign: "center",
          color: "text.secondary",
          border: 1,
          borderStyle: "dashed",
          borderColor: "divider",
          borderRadius: 2,
        }}
      >
        <CampaignOutlinedIcon fontSize="large" />
        <Typography variant="body2" mt={1}>
          Nenhum comunicado cadastrado.
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <TableContainer sx={{ border: 1, borderColor: "divider", borderRadius: 2 }}>
        <Table size="small" sx={{ minWidth: 800 }} aria-label="Lista de comunicados">
          <TableHead>
            <TableRow sx={{ "& th": { fontWeight: 600, bgcolor: "action.hover" } }}>
              <TableCell>Título</TableCell>
              <TableCell>Destinatários</TableCell>
              <TableCell>Criado Por</TableCell>
              <TableCell>Criado em</TableCell>
              <TableCell>Data Hora Para</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {comunicados.content.map((comunicado) => (
              <TableRow
                key={comunicado.codigo}
                hover
                onClick={() => setComunicado(comunicado)}
                sx={{ cursor: "pointer" }}
              >
                <TableCell>
                  <Typography variant="body2" fontWeight={500}>
                    {comunicado.titulo}
                  </Typography>
                  {comunicado.categoria && (
                    <Typography variant="caption" color="text.secondary">
                      {comunicado.categoria.descricao}
                    </Typography>
                  )}
                </TableCell>
                <TableCell>
                  <Typography variant="body2">{comunicado.enviarPara}</Typography>
                  {comunicado.enviarPor && (
                    <Typography variant="caption" color="text.secondary">
                      por {comunicado.enviarPor}
                    </Typography>
                  )}
                </TableCell>
                <TableCell>{comunicado.usuario?.nome ?? ""}</TableCell>
                <TableCell>{dateTimeFormat(comunicado.createdAt)}</TableCell>
                <TableCell>
                  {comunicado.dataHoraPara ? dateTimeFormat(comunicado.dataHoraPara) : ""}
                </TableCell>
                <TableCell>
                  <ComunicadoStatusChip
                    comunicado={comunicado}
                    comunicadoAprovacao={comunicadoAprovacao}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[]}
        rowsPerPage={comunicados.size || 0}
        component="div"
        count={comunicados.totalElements}
        page={comunicados.number}
        onPageChange={handleChangePage}
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? `${count} registros` : `mais de ${to}`}`
        }
        ActionsComponent={TablePaginationActions}
      />
    </Box>
  );
}
